import React, {ReactNode, FC} from 'react';

import {IFormEntityMeta} from 'entities/metadata';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {TModalComponentInterface} from 'store/slices/modals-slice';
import {
    selectWarningVisibilitySelector,
    resolveModalDirtiness,
    setWarningVisibility,
} from 'store/slices/warning-slice';

import {ConfirmModal} from '../confirm-modal/confirm-modal';

const WARNING_MESSAGE = 'У вас есть несохраненные изменения, при закрытии формы изменения не будут сохранены.\n'
    + 'Закрыть форму?';

interface IFormCloseWarningWrapperProps extends TModalComponentInterface {
    entityName: string;
    metadata: IFormEntityMeta;
    children: (handleClose: () => void, visible: boolean) => ReactNode;
}

/**
 * Добавляет в форму модальное окно с предупреждением если форма dirty (ее редактировали) при закрытии формы
 */
export const FormCloseWarning: FC<IFormCloseWarningWrapperProps> = ({
    entityName,
    onClose,
    children,
    metadata,
}: IFormCloseWarningWrapperProps) => {
    const dispatch = useAppDispatch();
    const warningVisible = useAppSelector(state => selectWarningVisibilitySelector(entityName)(state));
    const handleClose = () => {
        dispatch(resolveModalDirtiness({entityName, metadata, onClose}));
    };

    const handleCloseCancel = () => {
        dispatch(setWarningVisibility({entityName, warningVisible: false}));
    };

    const handleWarningClose = () => {
        dispatch(setWarningVisibility({entityName, warningVisible: false}));
        onClose();
    };

    return (
        <>
            {children(handleClose, !warningVisible)}
            <ConfirmModal
                title="Предупреждение"
                visible={warningVisible || false}
                content={WARNING_MESSAGE}
                onCancel={handleWarningClose}
                cancelText="Закрыть форму"
                onConfirm={handleCloseCancel}
                approveText="Вернуться к редактированию"
            />
        </>
    );
};
